export const APP_NAME = 'file-transfer';
